import { useState, useCallback, useEffect } from "react"
import { localizeDecimalSeparator, stringToNumber } from "utils/utils"

export default function useInputNumber(initValue: number | string): [
    string,
    number | null,
    (val: string | number) => void,
    (val: string | number) => void
] {
    const localizedInitValue = localizeDecimalSeparator(initValue)
    const [value, setValue] = useState<string>(localizedInitValue)
    const numberValue = stringToNumber(value)

    useEffect(() => {
        setValue(localizeDecimalSeparator(initValue))
    }, [initValue])

    const handleSetValue = useCallback((val: string | number) => {
        if (typeof val === "number") {
            if (isNaN(val)) {
                setValue("")
                return
            }
            setValue(val.toString())
            return
        }
        setValue(val)
    }, [])

    const handleSetInitValue = useCallback((val: string | number) => {
        setValue(localizeDecimalSeparator(val))
    }, [])

    return [value, numberValue, handleSetValue, handleSetInitValue]
}
